<template>
  <div class="search_container">
    <el-form
      ref="form"
      class="search_form"
      :model="searchForm"
      label-width="80px"
      label-position="left"
    >
      <!-- 政策通知 start -->
      <div class="w_395" v-if="searchType == 'policyMes'">
        <el-form-item label="主题：" label-width="48px">
          <el-input
            v-model="searchForm.msgTitle"
            placeholder="请输入主题"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_395" v-if="searchType == 'policyMes'">
        <el-form-item label="状态：" label-width="48px">
          <el-select v-model="searchForm.state" placeholder="请选择状态">
            <el-option
              v-for="item in stateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="w_790" v-if="searchType == 'policyMes'">
        <el-form-item label="发布时间：">
          <template>
            <div class="form_date_picker">
              <el-date-picker
                v-model="searchForm.dateList"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </div>
      <!-- 政策通知 end -->

      <!-- 政策文件 start -->
      <div class="w_395" v-if="searchType == 'policyFile'">
        <el-form-item label="文件名称：">
          <el-input
            v-model="searchForm.fileName"
            placeholder="请输入文件名称"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_395" v-if="searchType == 'policyFile'">
        <el-form-item label="发布人：" label-width="64px">
          <el-input
            v-model="searchForm.fromUserName"
            placeholder="请输入发布人"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_790" v-if="searchType == 'policyFile'">
        <el-form-item label="发布时间：">
          <template>
            <div class="form_date_picker">
              <el-date-picker
                v-model="searchForm.dateList"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </div>
      <!-- 政策文件 end -->

      <!-- 企业通知 start -->
      <div class="w_395" v-if="searchType == 'enterpriseMes'">
        <el-form-item label="主题：" label-width="48px">
          <el-input
            v-model="searchForm.msgTitle"
            placeholder="请输入主题"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_395" v-if="searchType == 'enterpriseMes'">
        <el-form-item label="发布人：" label-width="64px">
          <el-input
            v-model="searchForm.fromUserName"
            placeholder="请输入发布人"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_790" v-if="searchType == 'enterpriseMes'">
        <el-form-item label="发布时间：">
          <template>
            <div class="form_date_picker">
              <el-date-picker
                v-model="searchForm.dateList"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </div>
      <div class="w_395" v-if="searchType == 'enterpriseMes'">
        <el-form-item label="状态：" label-width="48px">
          <el-select v-model="searchForm.state" placeholder="请选择状态">
            <el-option
              v-for="item in stateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <!-- 企业通知 end -->

      <!-- 管理制度 start -->
      <div class="w_395" v-if="searchType == 'adminSystem'">
        <el-form-item label="制度名称：">
          <el-input
            v-model="searchForm.systemName"
            placeholder="请输入制度名称"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_395" v-if="searchType == 'adminSystem'">
        <el-form-item label="上传人：" label-width="64px">
          <el-input
            v-model="searchForm.uploading"
            placeholder="请输入上传人"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_790" v-if="searchType == 'adminSystem'">
        <el-form-item label="发布时间：">
          <template>
            <div class="form_date_picker">
              <el-date-picker
                v-model="searchForm.dateList"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </div>
      <!-- 管理制度 end -->

      <!-- 从业人员基本信息 start -->
      <div class="w_395" v-if="searchType == 'obtainStaff'">
        <el-form-item label="姓名：" label-width="48px">
          <el-input
            v-model="searchForm.userName"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_395 flex_center" v-if="searchType == 'obtainStaff'">
        <el-form-item label="身份证号：">
          <el-input
            v-model="searchForm.idCard"
            placeholder="请输入身份证号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_395 flex_center" v-if="searchType == 'obtainStaff'">
        <el-form-item label="手机号：" label-width="64px">
          <el-input
            v-model="searchForm.phone"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_395 flex_end" v-if="searchType == 'obtainStaff'">
        <el-form-item label="岗位类别：">
          <el-select v-model="searchForm.postType" placeholder="请选择岗位类别">
            <el-option
              v-for="item in postTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <!-- 从业人员基本信息 end -->

      <!-- 离职履历 start -->
      <div class="w_395" v-if="searchType == 'dimissionStaff'">
        <el-form-item label="姓名：" label-width="48px">
          <el-input
            v-model="searchForm.userName"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_395 flex_center" v-if="searchType == 'dimissionStaff'">
        <el-form-item label="身份证号：">
          <el-input
            v-model="searchForm.idCard"
            placeholder="请输入身份证号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_395 flex_center" v-if="searchType == 'dimissionStaff'">
        <el-form-item label="手机号：" label-width="64px">
          <el-input
            v-model="searchForm.phone"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_395 flex_end" v-if="searchType == 'dimissionStaff'">
        <el-form-item label="岗位类别：">
          <el-select v-model="searchForm.postType" placeholder="请选择岗位类别">
            <el-option
              v-for="item in postTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <!-- 离职履历 end -->

      <!-- 车辆基本信息 start -->
      <div class="w_395" v-if="searchType == 'carInfo'">
        <el-form-item label="车牌号码：">
          <el-input
            v-model="searchForm.carNumber"
            placeholder="请输入车牌号码"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_395 flex_center" v-if="searchType == 'carInfo'">
        <el-form-item label="车辆颜色：">
          <el-select v-model="searchForm.carColor" placeholder="请选择车牌颜色">
            <el-option
              v-for="item in carColorList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="w_395 flex_center" v-if="searchType == 'carInfo'">
        <el-form-item label="车辆营运性质：" label-width="96px">
          <el-select
            v-model="searchForm.carType"
            placeholder="请选择车辆营运性质"
          >
            <el-option
              v-for="item in carTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="w_395 flex_end" v-if="searchType == 'carInfo'">
        <el-form-item label="车辆状态：">
          <el-select v-model="searchForm.carState" placeholder="请选择车辆状态">
            <el-option
              v-for="item in carStateList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <!-- 车辆基本信息 end -->

      <!-- 车辆技术档案 start -->
      <div class="w_526" v-if="searchType == 'carTechnology'">
        <el-form-item label="车牌号码：">
          <el-input
            v-model="searchForm.carNumber"
            placeholder="请输入车牌号码"
          ></el-input>
        </el-form-item>
      </div>

      <div class="w_526 flex_center" v-if="searchType == 'carTechnology'">
        <el-form-item label="车辆颜色：">
          <el-select v-model="searchForm.carColor" placeholder="请选择车牌颜色">
            <el-option
              v-for="item in carColorList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="w_526 flex_end" v-if="searchType == 'carTechnology'">
        <el-form-item label="车辆营运性质：" label-width="96px">
          <el-select
            v-model="searchForm.carType"
            placeholder="请选择车辆营运性质"
          >
            <el-option
              v-for="item in carTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <!-- 车辆技术档案 end -->

      <!-- 维修档案 - 车辆维修记录 start -->
      <div class="w_395" v-if="searchType == 'maintainRecord_0'">
        <el-form-item label="起始时间：">
          <el-date-picker
            type="date"
            placeholder="请选择起始时间"
            v-model="searchForm.startTime"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </div>
      <div class="w_395 flex_center" v-if="searchType == 'maintainRecord_0'">
        <el-form-item label="截止时间：">
          <el-date-picker
            type="date"
            placeholder="请选择截止时间"
            v-model="searchForm.endTime"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </div>
      <div class="w_395" v-if="searchType == 'maintainRecord_0'">
        <el-form-item label="车牌号码：">
          <el-input
            v-model="searchForm.carNumber"
            placeholder="请输入车牌号码"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_395 flex_end" v-if="searchType == 'maintainRecord_0'">
        <el-form-item label="车辆营运性质：" label-width="96px">
          <el-select
            v-model="searchForm.carType"
            placeholder="请选择车辆营运性质"
          >
            <el-option
              v-for="item in carTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="w_395" v-if="searchType == 'maintainRecord_0'">
        <el-form-item label="维修企业：">
          <el-input
            v-model="searchForm.repairCompanyName"
            placeholder="请输入维修企业"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_395 flex_center" v-if="searchType == 'maintainRecord_0'">
        <el-form-item label="维修状态：">
          <el-select
            v-model="searchForm.repairState"
            placeholder="请选择维修状态"
          >
            <el-option
              v-for="item in repairList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <!-- 维修档案 - 车辆维修记录 end -->

      <!-- 维修档案 - 车辆检测记录 start -->
      <div class="w_526" v-if="searchType == 'maintainRecord_1'">
        <el-form-item label="起始时间：">
          <el-date-picker
            type="date"
            placeholder="请选择起始时间"
            v-model="searchForm.startTime"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </div>
      <div class="w_526 flex_center" v-if="searchType == 'maintainRecord_1'">
        <el-form-item label="截止时间：">
          <el-date-picker
            type="date"
            placeholder="请选择截止时间"
            v-model="searchForm.endTime"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </div>
      <div class="w_526 flex_end" v-if="searchType == 'maintainRecord_1'">
        <el-form-item label="车牌号码：">
          <el-input
            v-model="searchForm.carNumber"
            placeholder="请输入车牌号码"
          ></el-input>
        </el-form-item>
      </div>
      <!-- 维修档案 - 车辆检测记录 end -->

      <!-- 维护计划 start -->
      <div class="w_395" v-if="searchType == 'maintenancePlan'">
        <el-form-item label="车牌号码：">
          <el-input
            v-model="searchForm.carNumber"
            placeholder="请输入车牌号码"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_395" v-if="searchType == 'maintenancePlan'">
        <el-form-item label="车辆颜色：">
          <el-select v-model="searchForm.carColor" placeholder="请选择车牌颜色">
            <el-option
              v-for="item in carColorList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="w_395 flex_center" v-if="searchType == 'maintenancePlan'">
        <el-form-item label="车辆营运性质：" label-width="96px">
          <el-select
            v-model="searchForm.carType"
            placeholder="请选择车辆营运性质"
          >
            <el-option
              v-for="item in carTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="w_395 flex_end" v-if="searchType == 'maintenancePlan'">
        <el-form-item label="车辆状态：">
          <el-select v-model="searchForm.carState" placeholder="请选择车辆状态">
            <el-option
              v-for="item in carStateList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="w_395" v-if="searchType == 'maintenancePlan'">
        <el-form-item label="计划类型：">
          <el-select v-model="searchForm.planType" placeholder="请选择计划类型">
            <el-option
              v-for="item in planSelectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <!-- 维护计划 end -->

      <!-- 驾驶员台账 start -->
      <div class="w_526" v-if="searchType == 'driverLedger'">
        <el-form-item label="姓名：" label-width="48px">
          <el-input
            v-model="searchForm.userName"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_526 flex_center" v-if="searchType == 'driverLedger'">
        <el-form-item label="身份证号：">
          <el-input
            v-model="searchForm.idCard"
            placeholder="请输入身份证号"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_526 flex_end" v-if="searchType == 'driverLedger'">
        <el-form-item label="手机号：" label-width="64px">
          <el-input
            v-model="searchForm.phone"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
      </div>
      <!-- 驾驶员台账 end -->

      <!-- 隐患整改台账 start -->
      <div class="w_395" v-if="searchType == 'dangerLedger'">
        <el-form-item label="检查人：" label-width="64px">
          <el-select v-model="searchForm.checkId" placeholder="请选择检查人">
            <el-option
              v-for="item in checkIdList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="w_395" v-if="searchType == 'dangerLedger'">
        <el-form-item label="状态：" label-width="48px">
          <el-select v-model="searchForm.state" placeholder="请选择状态">
            <el-option
              v-for="item in checkStateList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="w_790" v-if="searchType == 'dangerLedger'">
        <el-form-item label="检查日期：">
          <template>
            <div class="form_date_picker">
              <el-date-picker
                v-model="searchForm.dateList"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </div>
      <!-- 隐患整改台账 end -->

      <!-- 安全活动奖罚台账 start -->
      <div class="w_790" v-if="searchType == 'safeActivity'">
        <el-form-item label="考核时间：">
          <template>
            <div class="form_date_picker_1">
              <el-date-picker
                v-model="searchForm.dateList"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </div>
      <div class="w_790 flex_end" v-if="searchType == 'safeActivity'">
        <el-form-item label="被考核人：">
          <el-select
            v-model="searchForm.examinedId"
            placeholder="请选择被考核人"
          >
            <el-option
              v-for="item in checkIdList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <!-- 安全活动奖罚台账 end -->

      <!-- 安全生产专项资金使用记录 start -->
      <div class="w_790" v-if="searchType == 'safeExpenditure_0'">
        <el-form-item label="投入时间：">
          <template>
            <div class="form_date_picker_1">
              <el-date-picker
                v-model="searchForm.dateList"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </div>
      <!-- 安全生产专项资金使用记录 end -->

      <!-- 职工劳务用品发放记录 start -->
      <div class="w_790" v-if="searchType == 'safeExpenditure_1'">
        <el-form-item label="领用日期：">
          <template>
            <div class="form_date_picker_1">
              <el-date-picker
                v-model="searchForm.dateList"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </div>
      <div class="w_790 flex_end" v-if="searchType == 'safeExpenditure_1'">
        <el-form-item label="品名：" label-width="48px">
          <el-input
            v-model="searchForm.goods"
            placeholder="请输入品名"
          ></el-input>
        </el-form-item>
      </div>
      <!-- 职工劳务用品发放记录 end -->

      <!-- 交通违法教育跟踪处理 start -->
      <div class="w_790" v-if="searchType == 'trafficTeach'">
        <el-form-item label="谈话时间：">
          <template>
            <div class="form_date_picker_1">
              <el-date-picker
                v-model="searchForm.dateList"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </div>
      <!-- 交通违法教育跟踪处理 end -->

      <!-- 交通违法事故登记 start -->
      <div class="w_790" v-if="searchType == 'trafficInfringe'">
        <el-form-item label="发生时间：">
          <template>
            <div class="form_date_picker_1">
              <el-date-picker
                v-model="searchForm.dateList"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </div>
      <!-- 交通违法事故登记 end -->

      <!-- 车辆动态监管 4个模块 start -->
      <div class="w_395" v-if="searchType == 'carRegulation'">
        <el-form-item label="驾驶员：" label-width="64px">
          <el-input
            v-model="searchForm.userName"
            placeholder="请输入驾驶员"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_395 flex_center" v-if="searchType == 'carRegulation'">
        <el-form-item label="车牌号码：">
          <el-input
            v-model="searchForm.idCard"
            placeholder="请输入车牌号码"
          ></el-input>
        </el-form-item>
      </div>
      <!-- 车辆动态监管 4个模块 end -->

      <!-- 行前测评记录 start -->
      <div class="w_790" v-if="searchType == 'preparationRecord'">
        <el-form-item label="评测时间：">
          <template>
            <div class="form_date_picker_3">
              <el-date-picker
                v-model="searchForm.dateList"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </div>
      <div class="w_395 flex_center" v-if="searchType == 'preparationRecord'">
        <el-form-item label="车牌号码：">
          <el-input
            v-model="searchForm.carNumber"
            placeholder="请输入车牌号码"
          ></el-input>
        </el-form-item>
      </div>

      <div class="w_395 flex_end" v-if="searchType == 'preparationRecord'">
        <el-form-item label="驾驶员：" label-width="64px">
          <el-input
            v-model="searchForm.states"
            placeholder="请输入驾驶员"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_526" v-if="searchType == 'preparationRecord'">
        <el-form-item label="行车安全测评：" label-width="96px">
          <el-select
            v-model="searchForm.preparation"
            placeholder="请选择行车安全测评"
          >
            <el-option
              v-for="item in preparationList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <!-- 行前测评记录 end -->

      <!-- 出行安全警示信息 start -->
      <div class="w_526" v-if="searchType == 'carSafety'">
        <el-form-item label="提醒主题：">
          <el-input
            v-model="searchForm.title"
            placeholder="请输入主题"
          ></el-input>
        </el-form-item>
      </div>
      <div class="w_526 flex_center" v-if="searchType == 'carSafety'">
        <el-form-item label="业务类型：">
          <el-select
            v-model="searchForm.carService"
            placeholder="请选择业务类型"
          >
            <el-option
              v-for="item in carTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="w_526 flex_end" v-if="searchType == 'carSafety'">
        <el-form-item label="状态：" label-width="48px">
          <el-select v-model="searchForm.state" placeholder="请选择状态">
            <el-option
              v-for="item in stateList2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <!-- 出行安全警示信息 end -->

      <!-- 消息中心模块 start -->
      <div class="w_790" v-if="searchType == 'messageCenter'">
        <el-form-item label="查询前后时间：" label-width="112px">
          <template>
            <div class="form_date_picker_1">
              <el-date-picker
                v-model="searchForm.messageDate"
                :default-value="this.searchForm.messageDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                align="right"
                unlink-panels
                :picker-options="pickerOptions"
                :clearable="false"
              >
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </div>
      <!-- 消息中心模块 end -->

      <!-- 用户管理 start -->
      <div class="w_395" v-if="searchType == 'userAdmin'">
        <el-form-item label="用户姓名：">
          <el-input
            v-model="searchForm.userName"
            placeholder="请输入用户姓名"
          ></el-input>
        </el-form-item>
      </div>

      <div class="w_395" v-if="searchType == 'userAdmin'">
        <el-form-item label="角色：" label-width="48px">
          <el-select v-model="searchForm.roleId" placeholder="请选择角色">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="w_790" v-if="searchType == 'userAdmin'">
        <el-form-item label="创建时间：">
          <template>
            <div class="form_date_picker">
              <el-date-picker
                v-model="searchForm.dateList"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
      </div>
      <!-- 用户管理 end -->
      <div
        :class="[
          'w_395',
          searchType == 'enterpriseMes' || searchType == 'maintenancePlan'
            ? 'w_592_5'
            : '',
        ]"
      >
        <el-button class="search_btn btns" @click="searchBtn">查询</el-button>
        <el-button class="reset_btn btns" @click="resetBtn">重置</el-button>
      </div>
      <div
        :class="[
          'w_395',
          searchType == 'enterpriseMes' || searchType == 'maintenancePlan'
            ? 'w_592_5'
            : '',
        ]"
      >
        <div
          class="btns_box"
          v-if="
            searchType == 'enterpriseMes' ||
            searchType == 'policyFile' ||
            searchType == 'policyMes' ||
            searchType == 'adminSystem' ||
            searchType == 'obtainStaff' ||
            searchType == 'maintainRecord_0' ||
            searchType == 'maintainRecord_1' ||
            searchType == 'dangerLedger' ||
            searchType == 'carInfo' ||
            searchType == 'carSafety' ||
            searchType == 'userAdmin' ||
            searchType == 'safeActivity' ||
            searchType == 'safeExpenditure_0' ||
            searchType == 'safeExpenditure_1' ||
            searchType == 'trafficInfringe' ||
            searchType == 'trafficTeach'
          "
        >
          <!-- ||  searchType == 'driverLedger' -->
          <el-button class="search_btn btns" @click="addBtn">新增</el-button>
          <el-button class="search_btn btns" @click="exportBtn">导出</el-button>
        </div>
        <div class="btns_box" v-else>
          <el-button class="search_btn btns" @click="exportBtn">导出</el-button>
        </div>
      </div>
      <!-- <div class="w_395">
        
        </div> -->
      <!-- </el-row> -->
    </el-form>
  </div>
</template>

<script>
import { dateTransition } from "@/utils/util";
export default {
  name: "",
  data() {
    return {
      searchForm: {
        messageDate: [],
      },
      stateList: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "未读",
        },
        {
          value: 2,
          label: "已读",
        },
        {
          value: 3,
          label: "已回复",
        },
      ],
      stateList2: [
        {
          value: 1,
          label: "开启",
        },
        {
          value: 0,
          label: "关闭",
        },
      ],
      disposeList: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "已处理",
        },
        {
          value: 2,
          label: "未处理",
        },
      ],
      postTypeList: [], // 岗位类别下拉数据
      carColorList: [], // 车辆颜色下拉数据
      carTypeList: [], // 车辆营运性质下拉数据
      carStateList: [
        {
          id: 1,
          name: "有效",
        },
        {
          id: 2,
          name: "无效",
        },
      ], // 车辆状态下拉数据
      planSelectList: [], // 维护计划下拉数据
      isExaminationList: [
        {
          id: 1,
          name: "未完成",
        },
        {
          id: 2,
          name: "已完成",
        },
      ], // 出车例检状态下拉
      preparationList: [], // 行前安全测评下拉数据
      checkStateList: [], // 隐患整改下拉数据
      checkIdList: [], // 检查人下拉数据
      repairList: [],
      roleList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 91);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近半年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 183);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  components: {},
  props: {
    searchType: {
      type: String,
      default: "",
    },
    limit: {
      type: Number,
      default: 10,
    },
  },
  created() {
    if (
      this.searchType == "obtainStaff" ||
      this.searchType == "dimissionStaff"
    ) {
      this.getSelectList();
    }
    if (this.searchType == "carInfo" || this.searchType == "carTechnology") {
      this.getColorSelectList();
      this.getCarTypeList();
    }
    if (this.searchType == "maintenancePlan") {
      this.getPlanSelect();
      this.getColorSelectList();
      this.getCarTypeList();
    }
    if (this.searchType == "preparationRecord") {
      this.getCarTypeList();
      this.getBeforeStateList();
    }
    if (this.searchType == "carSafety") {
      this.getCarTypeList();
    }
    if (this.searchType == "dangerLedger") {
      this.getYinghuan();
    }
    if (this.searchType == "maintainRecord_0") {
      this.getCarTypeList();
      this.getRepairSelect();
    }
    if (this.searchType == "userAdmin") {
      this.$http.getRoleSelect().then((res) => {
        if (res.code == 0) {
          this.roleList = res.data;
        } else {
          this.roleList = [];
        }
      });
    }
    if (this.searchType == "safeActivity") {
      this.$http.getDriverList().then((res) => {
        if (res.code == 0) {
          this.checkIdList = res.data;
        }
      });
    }
    if (this.searchType == "messageCenter") {
      const date = new Date();
      this.searchForm.messageDate.push(
        dateTransition(date.setTime(date - 3600 * 1000 * 24 * 7)),
        dateTransition(new Date())
      );
    }
  },
  methods: {
    getPlanSelect() {
      this.$http.getPlanSelect().then((res) => {
        if (res.code == 0) {
          this.planSelectList = res.data;
        } else {
          this.planSelectList = [];
        }
      });
    },
    getRepairSelect() {
      this.$http.getRepairSelect(1).then((res) => {
        if (res.code == 0) {
          this.repairList = res.data;
        } else {
          this.repairList = [];
        }
      });
    },
    getYinghuan() {
      this.$http.getRectifyState().then((res) => {
        if (res.code == 0) {
          this.checkStateList = res.data;
        }
      });
      this.$http.getDriverList().then((res) => {
        if (res.code == 0) {
          this.checkIdList = res.data;
        }
      });
    },
    getBeforeStateList() {
      this.$http.getBeforeStateSelect().then((res) => {
        if (res.code == 0) {
          this.preparationList = res.data;
        } else {
          this.preparationList = [];
        }
      });
    },
    getSelectList() {
      this.$http.getDriverSelect(1).then((res) => {
        if (res.code == 0) {
          this.postTypeList = res.data;
        } else {
          this.postTypeList = [];
        }
      });
    },
    getColorSelectList() {
      this.$http.getSelect(1).then((res) => {
        if (res.code == 0) {
          this.carColorList = res.data;
        } else {
          this.carColorList = [];
        }
      });
    },
    getCarTypeList() {
      this.$http.getSelect(2).then((res) => {
        if (res.code == 0) {
          this.carTypeList = res.data;
        } else {
          this.carTypeList = [];
        }
      });
    },
    resetBtn() {
      console.log(this.searchType);
      if (this.searchType == "messageCenter") {
        this.searchForm.messageDate = [];
        const date = new Date();
        this.searchForm.messageDate.push(
          dateTransition(date.setTime(date - 3600 * 1000 * 24 * 7)),
          dateTransition(new Date())
        );
        this.$parent.getList({
          page: 1,
          limit: 10,
          startTimeStr: this.searchForm.messageDate[0],
          endTimeStr: this.searchForm.messageDate[1],
          isPage: true,
        });
        this.$emit("searchParams", {
          page: 1,
          limit: 10,
          startTimeStr: this.searchForm.messageDate[0],
          endTimeStr: this.searchForm.messageDate[1],
          isPage: true,
        });
      } else if (
        this.searchType == "policyMes" ||
        this.searchType == "policyFile" ||
        this.searchType == "enterpriseMes"
      ) {
        this.searchForm = {};
        this.$parent.getList({
          page: 1,
          limit: 10,
          isPage: true,
          msgType:
            this.searchType == "policyMes"
              ? 1
              : this.searchType == "policyFile"
              ? 2
              : 3,
        });
        this.$emit("searchParams", {
          page: 1,
          limit: 10,
          isPage: true,
          msgType:
            this.searchType == "policyMes"
              ? 1
              : this.searchType == "policyFile"
              ? 2
              : 3,
        });
      } else {
        this.searchForm = {};
        this.$parent.getList({
          page: 1,
          limit: 10,
          isPage: true,
        });
        this.$emit("searchParams", {
          page: 1,
          limit: 10,
          isPage: true,
        });
      }
      
    },
    searchBtn() {
      let params = {};
      switch (this.searchType) {
        case "policyMes": // 政策通知
          params = {
            dealState: this.searchForm.disposeState
              ? this.searchForm.disposeState
              : 0, // 处理状态 0全部 1未处理 2已处理 ,
            endTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[1])
              : "", // 发布结束时间 yyyy-MM-dd
            limit: this.limit, // 分页大小
            msgType: 1, // 消息状态 1政策通知 2政策文件 3企业通知
            page: 1,
            publicName: "", // 发布人
            readState: this.searchForm.state ? this.searchForm.state : 0, // 阅读状态 0全部 1未读 2已读 3已回复
            searchTitle: this.searchForm.msgTitle, // 主题
            startTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[0])
              : "", // 发布开始时间 yyyy-MM-dd
            isPage: true,
          };
          this.$parent.getList(params);
          break;

        case "policyFile": // 政策文件
          params = {
            dealState: 0, // 处理状态 0全部 1未处理 2已处理 ,
            endTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[1])
              : "", // 发布结束时间 yyyy-MM-dd
            limit: this.limit, // 分页大小
            msgType: 2, // 消息状态 1政策通知 2政策文件 3企业通知
            page: 1,
            publicName: this.searchForm.fromUserName, // 发布人
            readState: 0, // 阅读状态 0全部 1未读 2已读 3已回复
            searchTitle: this.searchForm.fileName, // 主题
            startTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[0])
              : "", // 发布开始时间 yyyy-MM-dd
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "enterpriseMes": //企业通知
          params = {
            dealState: 0, // 处理状态 0全部 1未处理 2已处理 ,
            endTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[1])
              : "", // 发布结束时间 yyyy-MM-dd
            limit: this.limit, // 分页大小
            msgType: 3, // 消息状态 1政策通知 2政策文件 3企业通知
            page: 1,
            publicName: this.searchForm.fromUserName, // 发布人
            readState: this.searchForm.state, // 阅读状态 0全部 1未读 2已读 3已回复
            searchTitle: this.searchForm.msgTitle, // 主题
            startTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[0])
              : "", // 发布开始时间 yyyy-MM-dd
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "adminSystem": //企业通知
          params = {
            endTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[1])
              : "", //上传时间结束 yyyy-MM-dd ,
            limit: this.limit, //分页大小 ,
            manageName: this.searchForm.systemName, //制度名称搜索 ,
            page: 1, //页码 ,
            pubName: this.searchForm.uploading, //上传人搜索 ,
            startTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[0])
              : "", // 上传时间开始 yyyy-MM-dd
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "obtainStaff": //企业通知
          params = {
            driverCardCode: this.searchForm.idCard, //驾驶员身份证号 ,
            driverName: this.searchForm.userName, //驾驶员姓名 ,
            driverPhone: this.searchForm.phone, //驾驶员号码 ,
            limit: this.limit, //分页大小 ,
            page: 1, //页码 ,
            post: this.searchForm.postType, //岗位id ,
            type: 1, //驾驶员状态 1在职 2离线（默认1）
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "dimissionStaff": //企业通知
          params = {
            driverCardCode: this.searchForm.idCard, //驾驶员身份证号 ,
            driverName: this.searchForm.userName, //驾驶员姓名 ,
            driverPhone: this.searchForm.phone, //驾驶员号码 ,
            limit: this.limit, //分页大小 ,
            page: 1, //页码 ,
            post: this.searchForm.postType, //岗位id ,
            type: 2, //驾驶员状态 1在职 2离线（默认1）
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "carInfo":
          params = {
            carColor: this.searchForm.carColor,
            carNumber: this.searchForm.carNumber,
            carService: this.searchForm.carType,
            carState: this.searchForm.carState,
            limit: this.limit,
            page: 1,
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "carTechnology":
          params = {
            carColor: this.searchForm.carColor,
            carNumber: this.searchForm.states,
            carService: this.searchForm.carType,
            limit: this.limit,
            page: 1,
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "maintenancePlan":
          params = {
            carColor: this.searchForm.carColor,
            carNumber: this.searchForm.carNumber,
            carService: this.searchForm.carType,
            limit: this.limit,
            page: 1,
            planType: this.searchForm.planType,
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "carSafety":
          params = {
            carService: this.searchForm.carService,
            limit: this.limit,
            page: 1,
            state: this.searchForm.state,
            title: this.searchForm.title,
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "dangerLedger":
          params = {
            checkEndTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[1])
              : "",
            checkStartTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[0])
              : "",
            checkState: this.searchForm.state,
            checkUserName: this.searchForm.checkId,
            limit: this.limit,
            page: 1,
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "maintainRecord_0":
          params = {
            carNumber: this.searchForm.carNumber,
            carService: this.searchForm.carType,
            endTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[1])
              : "",
            limit: this.limit,
            page: 1,
            repairCompanyName: this.searchForm.repairCompanyName,
            repairState: this.searchForm.repairState,
            startTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[0])
              : "",
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "maintainRecord_1":
          params = {
            carNumber: this.searchForm.carNumber,
            endTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[1])
              : "",
            limit: this.limit,
            page: 1,
            startTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[0])
              : "",
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "userAdmin":
          params = {
            endTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[1])
              : "",
            limit: this.limit,
            page: 1,
            realName: this.searchForm.userName,
            roleId: this.searchForm.roleId,
            startTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[0])
              : "",
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "driverLedger": //企业通知
          params = {
            driverCardCode: this.searchForm.idCard, //驾驶员身份证号 ,
            driverName: this.searchForm.userName, //驾驶员姓名 ,
            driverPhone: this.searchForm.phone, //驾驶员号码 ,
            limit: this.limit, //分页大小 ,
            page: 1, //页码 ,
            post: 1, //岗位id ,
            type: 1, //驾驶员状态 1在职 2离线（默认1）
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "safeActivity":
          params = {
            endTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[1])
              : "",
            examinedId: this.searchForm.examinedId * 1,
            limit: this.limit,
            page: 1,
            startTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[0])
              : "",
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "safeExpenditure_0":
          params = {
            endTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[1])
              : "",
            isPage: false,
            limit: this.limit,
            page: 1,
            startTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[0])
              : "",
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "safeExpenditure_1":
          params = {
            endTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[1])
              : "",
            isPage: false,
            limit: this.limit,
            page: 1,
            goods: this.searchForm.goods,
            startTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[0])
              : "",
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "trafficTeach":
          params = {
            endTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[1])
              : "",
            isPage: false,
            limit: this.limit,
            pdateListage: 1,
            startTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[0])
              : "",
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "messageCenter":
          params = {
            endTimeStr: this.searchForm.messageDate
              ? dateTransition(this.searchForm.messageDate[1])
              : "",
            limit: this.limit,
            page: 1,
            startTimeStr: this.searchForm.messageDate
              ? dateTransition(this.searchForm.messageDate[0])
              : "",
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "trafficInfringe":
          params = {
            endTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[1])
              : "",
            limit: this.limit,
            page: 1,
            startTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[0])
              : "",
            isPage: true,
          };
          this.$parent.getList(params);
          break;
        case "preparationRecord":
          console.log("111", this.searchForm.preparation);
          params = {
            endTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[1])
              : "",
            limit: this.limit,
            page: 1,
            startTimeStr: this.searchForm.dateList
              ? dateTransition(this.searchForm.dateList[0])
              : "",
            isPage: true,
            driverName: this.searchForm.states,
            state: this.searchForm.preparation,
            carNumber: this.searchForm.carNumber,
          };
          this.$parent.getList(params);
          break;
      }
      this.$emit("searchParams", params);
      // this.$parent.searchFunction();
    },
    addBtn() {
      this.$parent.addFunction();
    },
    exportBtn() {
      this.$parent.downloadExport();
    },
  },
};
</script>

<style lang="less" scoped>
.search_form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
  .w_395 {
    width: 395px;
    height: 62px;
    white-space: nowrap;
  }
  .w_526 {
    width: 526px;
    height: 62px;
  }
  .w_790 {
    width: 790px;
    height: 62px;
  }
  .w_592_5 {
    width: 592.5px;
    height: 62px;
  }
  .flex_end {
    display: flex;
    justify-content: flex-end;
  }
  .flex_center {
    display: flex;
    justify-content: center;
  }
  // >div:nth-child(3n){
  //   margin-right: 20px;
  // }
  .btns {
    width: 104px;
    height: 36px;
    padding: 0;
    line-height: 36px;
    text-align: center;
    box-sizing: border-box;
  }
  .add_btn {
    background: #ffffff;
    border-radius: 4px;
    border: 2px solid #255A7E;
    color: #255A7E;
  }
  .search_btn {
    background: #255A7E;
    border-radius: 4px;
    color: #ffffff;
  }
  .reset_btn {
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #717171;
    color: #717171;
  }
  /deep/ .el-input__inner {
    width: 265px;
    height: 36px;
  }
  /deep/.el-form-item__label {
    white-space: nowrap;
  }
}
.form_date_picker {
  width: 100%;
  /deep/ .el-input__inner {
    width: 100%;
    height: 36px;
  }
}
.form_date_picker_1 {
  width: 100%;
  /deep/ .el-input__inner {
    width: calc(100% - 68px);
    height: 36px;
  }
}
.form_date_picker_2 {
  /deep/ .el-input__inner {
    width: 468px;
    height: 36px;
  }
}
.form_date_picker_3 {
  width: 100%;
  /deep/ .el-input__inner {
    width: calc(100% - 10px);
    height: 36px;
  }
}
.btns_box {
  display: flex;
  justify-content: flex-end;
  height: 62px;
}
.el-row {
  display: flex;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue